// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fp-page {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  animation: fadeIn 0.2s ease-in;
}

/* ── Top search bar ─────────────────────────────────────────────────────── */

.fp-top-bar {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.fp-page-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #e2e8f0;
  margin: 0;
  white-space: nowrap;
}

/* ── Search widget ─────────────────────────────────────────────────────── */

.fp-search-wrap {
  position: relative;
  flex: 1 1;
  max-width: 420px;
}

.fp-search-input {
  width: 100%;
  padding: 0.55rem 2rem 0.55rem 0.85rem;
  background: #1e293b;
  border: 1px solid #334155;
  border-radius: 8px;
  color: #e2e8f0;
  font-size: 0.9rem;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.15s;
}
.fp-search-input:focus { border-color: #f59e0b; }

.fp-search-clear {
  position: absolute;
  right: 0.5rem;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #64748b;
  font-size: 1.1rem;
  cursor: pointer;
  padding: 0;
  line-height: 1;
}
.fp-search-clear:hover { color: #f59e0b; }

.fp-search-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: #1e293b;
  border: 1px solid #334155;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0,0,0,0.4);
  z-index: 100;
  max-height: 280px;
  overflow-y: auto;
}

.fp-search-result {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.55rem 0.85rem;
  cursor: pointer;
  border-bottom: 1px solid #0f172a;
  transition: background 0.1s;
}
.fp-search-result:last-child { border-bottom: none; }
.fp-search-result:hover { background: #263248; }

.fp-res-name { color: #e2e8f0; font-size: 0.9rem; }
.fp-res-class { color: #64748b; font-size: 0.78rem; }

/* ── Empty state ───────────────────────────────────────────────────────── */

.fp-empty {
  text-align: center;
  padding: 4rem 1rem;
  color: #475569;
  font-size: 0.95rem;
}

.fp-loading { color: #64748b; font-size: 0.9rem; padding: 0.5rem 0; }
.fp-loading-main { padding: 3rem; text-align: center; }
.fp-error { color: #ef4444; font-size: 0.9rem; padding: 1rem; }

/* ── Header card ───────────────────────────────────────────────────────── */

.fp-header-card {
  background: #1e293b;
  border: 1px solid #334155;
  border-radius: 12px;
  padding: 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;
}

.fp-name {
  font-size: 1.6rem;
  font-weight: 700;
  color: #f1f5f9;
  margin: 0 0 0.2rem;
}

.fp-nickname {
  color: #94a3b8;
  font-size: 0.95rem;
  font-style: italic;
  margin: 0 0 0.75rem;
}

.fp-badges {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.fp-badge {
  font-size: 0.75rem;
  font-weight: 600;
  padding: 0.2rem 0.6rem;
  border-radius: 4px;
  text-transform: capitalize;
}
.fp-badge-class { background: rgba(99, 102, 241, 0.15); color: #818cf8; }
.fp-badge-style { background: rgba(245, 158, 11, 0.12); color: #f59e0b; }
.fp-badge-inactive { background: rgba(100, 116, 139, 0.15); color: #64748b; }

.fp-record {
  display: flex;
  align-items: baseline;
  gap: 0.3rem;
  font-size: 2.2rem;
  font-weight: 700;
}
.fp-record-wins { color: #10b981; }
.fp-record-losses { color: #ef4444; }
.fp-record-draws { color: #f59e0b; }
.fp-record-sep { color: #475569; font-weight: 300; }
.fp-record-label { text-align: center; color: #64748b; font-size: 0.75rem; margin-top: 0.2rem; letter-spacing: 0.05em; }

/* ── Info row ─────────────────────────────────────────────────────────── */

.fp-info-row {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.fp-info-item {
  background: #1e293b;
  border: 1px solid #334155;
  border-radius: 8px;
  padding: 0.6rem 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  min-width: 90px;
}
.fp-info-label { font-size: 0.7rem; color: #64748b; text-transform: uppercase; letter-spacing: 0.05em; }
.fp-info-val { font-size: 0.95rem; font-weight: 600; color: #e2e8f0; }

/* ── Ratings row ─────────────────────────────────────────────────────── */

.fp-ratings-row {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.fp-rating-card {
  background: #1e293b;
  border: 1px solid #334155;
  border-radius: 10px;
  padding: 0.85rem 1.25rem;
  text-align: center;
  min-width: 110px;
}
.fp-rating-val { font-size: 1.4rem; font-weight: 700; color: #f59e0b; }
.fp-rating-label { font-size: 0.73rem; color: #64748b; margin-top: 0.15rem; }
.fp-rd { color: #94a3b8; font-size: 0.7rem; }

/* ── Sections ─────────────────────────────────────────────────────────── */

.fp-section {
  background: #1e293b;
  border: 1px solid #334155;
  border-radius: 12px;
  padding: 1.25rem;
}

.fp-section-title {
  font-size: 0.85rem;
  font-weight: 600;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin: 0 0 1rem;
}

.fp-fight-count { color: #475569; font-weight: 400; text-transform: none; font-size: 0.8rem; }

.fp-data-warning {
  font-size: 0.78rem;
  color: #92400e;
  background: rgba(245, 158, 11, 0.08);
  border: 1px solid rgba(245, 158, 11, 0.2);
  border-radius: 6px;
  padding: 0.5rem 0.75rem;
  margin-bottom: 0.85rem;
}
.fp-data-warning a { color: #f59e0b; }

/* ── Career stats grid ────────────────────────────────────────────────── */

.fp-stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
  gap: 0.75rem;
}

.fp-stat-cell {
  background: #0f172a;
  border-radius: 8px;
  padding: 0.7rem 0.85rem;
}
.fp-stat-val {
  font-size: 1.15rem;
  font-weight: 700;
  color: #e2e8f0;
}
.fp-stat-unit { font-size: 0.7rem; color: #64748b; margin-left: 2px; }
.fp-stat-label { font-size: 0.7rem; color: #64748b; margin-top: 0.2rem; }

/* ── Fight history table ─────────────────────────────────────────────── */

.fp-history-table-wrap {
  overflow-x: auto;
}

.fp-history-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.855rem;
}
.fp-history-table th {
  text-align: left;
  color: #64748b;
  font-size: 0.72rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  padding: 0.4rem 0.6rem;
  border-bottom: 1px solid #334155;
}
.fp-history-table td {
  padding: 0.5rem 0.6rem;
  border-bottom: 1px solid #1a2740;
  vertical-align: middle;
}
.fp-history-table tr:last-child td { border-bottom: none; }
.fp-history-table tr:hover td { background: rgba(255,255,255,0.02); }

.fp-hist-date { color: #64748b; white-space: nowrap; }
.fp-hist-opp { color: #e2e8f0; font-weight: 500; }
.fp-hist-method { color: #94a3b8; }
.fp-hist-rnd { color: #94a3b8; text-align: center; }
.fp-hist-time { color: #94a3b8; white-space: nowrap; }
.fp-hist-event { color: #475569; font-size: 0.78rem; max-width: 200px; }

.fp-result {
  font-size: 0.72rem;
  font-weight: 700;
  padding: 0.15rem 0.45rem;
  border-radius: 3px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.fp-result-win { background: rgba(16, 185, 129, 0.12); color: #10b981; }
.fp-result-loss { background: rgba(239, 68, 68, 0.12); color: #ef4444; }
.fp-result-draw { background: rgba(245, 158, 11, 0.12); color: #f59e0b; }
.fp-result-nc { background: rgba(100, 116, 139, 0.12); color: #64748b; }

/* ── Matchup panel ────────────────────────────────────────────────────── */

.fp-matchup-panel {
  background: #1e293b;
  border: 1px solid #334155;
  border-radius: 12px;
  padding: 1.25rem;
}

.fp-matchup-search-row {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  flex-wrap: wrap;
  margin-bottom: 1rem;
}

.fp-matchup-vs {
  color: #94a3b8;
  font-size: 0.9rem;
  white-space: nowrap;
}

.fp-odds-section { margin-top: 0.5rem; }

.fp-odds-event {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  flex-wrap: wrap;
  margin-bottom: 0.85rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid #334155;
}
.fp-odds-event-name { color: #e2e8f0; font-weight: 600; font-size: 0.9rem; }
.fp-odds-event-date { color: #64748b; font-size: 0.8rem; }

.fp-title-badge {
  font-size: 0.7rem;
  font-weight: 700;
  padding: 0.15rem 0.5rem;
  border-radius: 3px;
  background: rgba(245, 158, 11, 0.15);
  color: #f59e0b;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.fp-status-badge {
  font-size: 0.7rem;
  font-weight: 600;
  padding: 0.15rem 0.5rem;
  border-radius: 3px;
  text-transform: capitalize;
}
.fp-status-upcoming { background: rgba(16, 185, 129, 0.12); color: #10b981; }
.fp-status-completed { background: rgba(100, 116, 139, 0.12); color: #64748b; }

.fp-odds-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.875rem;
}
.fp-odds-table th {
  text-align: left;
  color: #64748b;
  font-size: 0.72rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  padding: 0.4rem 0.75rem;
  border-bottom: 1px solid #334155;
}
.fp-odds-table td {
  padding: 0.55rem 0.75rem;
  border-bottom: 1px solid #1a2740;
}
.fp-odds-table tr:last-child td { border-bottom: none; }
.fp-odds-table tr:hover td { background: rgba(255,255,255,0.02); }

.fp-bk-name { color: #94a3b8; }
.fp-odds-val { font-weight: 700; font-size: 0.95rem; }
.fp-odds-pos { color: #10b981; }
.fp-odds-neg { color: #ef4444; }
.odds-dash { color: #475569; }

.fp-no-odds { color: #64748b; font-size: 0.875rem; margin: 0.5rem 0; }
.fp-no-fight { color: #64748b; font-size: 0.875rem; margin: 0.5rem 0; }

/* ── Probability bar ──────────────────────────────────────────────────────── */

.fp-prob-section {
  background: #0f172a;
  border-radius: 10px;
  padding: 1rem;
  margin-bottom: 1rem;
}

.fp-prob-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.65rem;
}

.fp-prob-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.fp-prob-method {
  font-size: 0.7rem;
  color: #475569;
  font-style: italic;
}

.fp-prob-bar-wrap {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.fp-prob-name {
  font-size: 0.78rem;
  font-weight: 600;
  white-space: nowrap;
  min-width: 80px;
}
.fp-prob-a { color: #10b981; text-align: right; }
.fp-prob-b { color: #f59e0b; }

.fp-prob-bar {
  flex: 1 1;
  height: 10px;
  border-radius: 5px;
  overflow: hidden;
  display: flex;
  background: #1e293b;
}

.fp-prob-fill { height: 100%; transition: width 0.4s ease; }
.fp-prob-fill-a { background: #10b981; }
.fp-prob-fill-b { background: #f59e0b; }

.fp-prob-pcts {
  display: flex;
  justify-content: space-between;
  margin-top: 0.35rem;
}
.fp-pct-a { font-size: 0.85rem; font-weight: 700; color: #10b981; }
.fp-pct-b { font-size: 0.85rem; font-weight: 700; color: #f59e0b; }
`, "",{"version":3,"sources":["webpack://./src/components/FighterProfile.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,8BAA8B;AAChC;;AAEA,8EAA8E;;AAE9E;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,mBAAmB;AACrB;;AAEA,6EAA6E;;AAE7E;EACE,kBAAkB;EAClB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,qCAAqC;EACrC,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;AACA,yBAAyB,qBAAqB,EAAE;;AAEhD;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,UAAU;EACV,cAAc;AAChB;AACA,yBAAyB,cAAc,EAAE;;AAEzC;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,sCAAsC;EACtC,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,wBAAwB;EACxB,eAAe;EACf,gCAAgC;EAChC,2BAA2B;AAC7B;AACA,+BAA+B,mBAAmB,EAAE;AACpD,0BAA0B,mBAAmB,EAAE;;AAE/C,eAAe,cAAc,EAAE,iBAAiB,EAAE;AAClD,gBAAgB,cAAc,EAAE,kBAAkB,EAAE;;AAEpD,6EAA6E;;AAE7E;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA,cAAc,cAAc,EAAE,iBAAiB,EAAE,iBAAiB,EAAE;AACpE,mBAAmB,aAAa,EAAE,kBAAkB,EAAE;AACtD,YAAY,cAAc,EAAE,iBAAiB,EAAE,aAAa,EAAE;;AAE9D,6EAA6E;;AAE7E;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,0BAA0B;AAC5B;AACA,kBAAkB,oCAAoC,EAAE,cAAc,EAAE;AACxE,kBAAkB,oCAAoC,EAAE,cAAc,EAAE;AACxE,qBAAqB,qCAAqC,EAAE,cAAc,EAAE;;AAE5E;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;AACA,kBAAkB,cAAc,EAAE;AAClC,oBAAoB,cAAc,EAAE;AACpC,mBAAmB,cAAc,EAAE;AACnC,iBAAiB,cAAc,EAAE,gBAAgB,EAAE;AACnD,mBAAmB,kBAAkB,EAAE,cAAc,EAAE,kBAAkB,EAAE,kBAAkB,EAAE,sBAAsB,EAAE;;AAEvH,4EAA4E;;AAE5E;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,eAAe;AACjB;AACA,iBAAiB,iBAAiB,EAAE,cAAc,EAAE,yBAAyB,EAAE,sBAAsB,EAAE;AACvG,eAAe,kBAAkB,EAAE,gBAAgB,EAAE,cAAc,EAAE;;AAErE,2EAA2E;;AAE3E;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;AAClB;AACA,iBAAiB,iBAAiB,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACtE,mBAAmB,kBAAkB,EAAE,cAAc,EAAE,mBAAmB,EAAE;AAC5E,SAAS,cAAc,EAAE,iBAAiB,EAAE;;AAE5C,4EAA4E;;AAE5E;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,kBAAkB,cAAc,EAAE,gBAAgB,EAAE,oBAAoB,EAAE,iBAAiB,EAAE;;AAE7F;EACE,kBAAkB;EAClB,cAAc;EACd,oCAAoC;EACpC,yCAAyC;EACzC,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;AACxB;AACA,qBAAqB,cAAc,EAAE;;AAErC,4EAA4E;;AAE5E;EACE,aAAa;EACb,4DAA4D;EAC5D,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA,gBAAgB,iBAAiB,EAAE,cAAc,EAAE,gBAAgB,EAAE;AACrE,iBAAiB,iBAAiB,EAAE,cAAc,EAAE,kBAAkB,EAAE;;AAExE,2EAA2E;;AAE3E;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;EACtB,gCAAgC;AAClC;AACA;EACE,sBAAsB;EACtB,gCAAgC;EAChC,sBAAsB;AACxB;AACA,qCAAqC,mBAAmB,EAAE;AAC1D,gCAAgC,kCAAkC,EAAE;;AAEpE,gBAAgB,cAAc,EAAE,mBAAmB,EAAE;AACrD,eAAe,cAAc,EAAE,gBAAgB,EAAE;AACjD,kBAAkB,cAAc,EAAE;AAClC,eAAe,cAAc,EAAE,kBAAkB,EAAE;AACnD,gBAAgB,cAAc,EAAE,mBAAmB,EAAE;AACrD,iBAAiB,cAAc,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;;AAEvE;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;AACA,iBAAiB,oCAAoC,EAAE,cAAc,EAAE;AACvE,kBAAkB,mCAAmC,EAAE,cAAc,EAAE;AACvE,kBAAkB,oCAAoC,EAAE,cAAc,EAAE;AACxE,gBAAgB,qCAAqC,EAAE,cAAc,EAAE;;AAEvE,4EAA4E;;AAE5E;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,mBAAmB,kBAAkB,EAAE;;AAEvC;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,uBAAuB;EACvB,gCAAgC;AAClC;AACA,sBAAsB,cAAc,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;AAC3E,sBAAsB,cAAc,EAAE,iBAAiB,EAAE;;AAEzD;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,0BAA0B;AAC5B;AACA,sBAAsB,oCAAoC,EAAE,cAAc,EAAE;AAC5E,uBAAuB,qCAAqC,EAAE,cAAc,EAAE;;AAE9E;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,gCAAgC;AAClC;AACA;EACE,wBAAwB;EACxB,gCAAgC;AAClC;AACA,kCAAkC,mBAAmB,EAAE;AACvD,6BAA6B,kCAAkC,EAAE;;AAEjE,cAAc,cAAc,EAAE;AAC9B,eAAe,gBAAgB,EAAE,kBAAkB,EAAE;AACrD,eAAe,cAAc,EAAE;AAC/B,eAAe,cAAc,EAAE;AAC/B,aAAa,cAAc,EAAE;;AAE7B,cAAc,cAAc,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;AACrE,eAAe,cAAc,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;;AAEtE,gFAAgF;;AAEhF;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;AACA,aAAa,cAAc,EAAE,iBAAiB,EAAE;AAChD,aAAa,cAAc,EAAE;;AAE7B;EACE,SAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA,gBAAgB,YAAY,EAAE,2BAA2B,EAAE;AAC3D,kBAAkB,mBAAmB,EAAE;AACvC,kBAAkB,mBAAmB,EAAE;;AAEvC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA,YAAY,kBAAkB,EAAE,gBAAgB,EAAE,cAAc,EAAE;AAClE,YAAY,kBAAkB,EAAE,gBAAgB,EAAE,cAAc,EAAE","sourcesContent":[".fp-page {\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n  animation: fadeIn 0.2s ease-in;\n}\n\n/* ── Top search bar ─────────────────────────────────────────────────────── */\n\n.fp-top-bar {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.fp-page-title {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #e2e8f0;\n  margin: 0;\n  white-space: nowrap;\n}\n\n/* ── Search widget ─────────────────────────────────────────────────────── */\n\n.fp-search-wrap {\n  position: relative;\n  flex: 1;\n  max-width: 420px;\n}\n\n.fp-search-input {\n  width: 100%;\n  padding: 0.55rem 2rem 0.55rem 0.85rem;\n  background: #1e293b;\n  border: 1px solid #334155;\n  border-radius: 8px;\n  color: #e2e8f0;\n  font-size: 0.9rem;\n  outline: none;\n  box-sizing: border-box;\n  transition: border-color 0.15s;\n}\n.fp-search-input:focus { border-color: #f59e0b; }\n\n.fp-search-clear {\n  position: absolute;\n  right: 0.5rem;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  color: #64748b;\n  font-size: 1.1rem;\n  cursor: pointer;\n  padding: 0;\n  line-height: 1;\n}\n.fp-search-clear:hover { color: #f59e0b; }\n\n.fp-search-dropdown {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  right: 0;\n  background: #1e293b;\n  border: 1px solid #334155;\n  border-radius: 8px;\n  box-shadow: 0 8px 24px rgba(0,0,0,0.4);\n  z-index: 100;\n  max-height: 280px;\n  overflow-y: auto;\n}\n\n.fp-search-result {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.55rem 0.85rem;\n  cursor: pointer;\n  border-bottom: 1px solid #0f172a;\n  transition: background 0.1s;\n}\n.fp-search-result:last-child { border-bottom: none; }\n.fp-search-result:hover { background: #263248; }\n\n.fp-res-name { color: #e2e8f0; font-size: 0.9rem; }\n.fp-res-class { color: #64748b; font-size: 0.78rem; }\n\n/* ── Empty state ───────────────────────────────────────────────────────── */\n\n.fp-empty {\n  text-align: center;\n  padding: 4rem 1rem;\n  color: #475569;\n  font-size: 0.95rem;\n}\n\n.fp-loading { color: #64748b; font-size: 0.9rem; padding: 0.5rem 0; }\n.fp-loading-main { padding: 3rem; text-align: center; }\n.fp-error { color: #ef4444; font-size: 0.9rem; padding: 1rem; }\n\n/* ── Header card ───────────────────────────────────────────────────────── */\n\n.fp-header-card {\n  background: #1e293b;\n  border: 1px solid #334155;\n  border-radius: 12px;\n  padding: 1.5rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 1rem;\n}\n\n.fp-name {\n  font-size: 1.6rem;\n  font-weight: 700;\n  color: #f1f5f9;\n  margin: 0 0 0.2rem;\n}\n\n.fp-nickname {\n  color: #94a3b8;\n  font-size: 0.95rem;\n  font-style: italic;\n  margin: 0 0 0.75rem;\n}\n\n.fp-badges {\n  display: flex;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.fp-badge {\n  font-size: 0.75rem;\n  font-weight: 600;\n  padding: 0.2rem 0.6rem;\n  border-radius: 4px;\n  text-transform: capitalize;\n}\n.fp-badge-class { background: rgba(99, 102, 241, 0.15); color: #818cf8; }\n.fp-badge-style { background: rgba(245, 158, 11, 0.12); color: #f59e0b; }\n.fp-badge-inactive { background: rgba(100, 116, 139, 0.15); color: #64748b; }\n\n.fp-record {\n  display: flex;\n  align-items: baseline;\n  gap: 0.3rem;\n  font-size: 2.2rem;\n  font-weight: 700;\n}\n.fp-record-wins { color: #10b981; }\n.fp-record-losses { color: #ef4444; }\n.fp-record-draws { color: #f59e0b; }\n.fp-record-sep { color: #475569; font-weight: 300; }\n.fp-record-label { text-align: center; color: #64748b; font-size: 0.75rem; margin-top: 0.2rem; letter-spacing: 0.05em; }\n\n/* ── Info row ─────────────────────────────────────────────────────────── */\n\n.fp-info-row {\n  display: flex;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.fp-info-item {\n  background: #1e293b;\n  border: 1px solid #334155;\n  border-radius: 8px;\n  padding: 0.6rem 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n  min-width: 90px;\n}\n.fp-info-label { font-size: 0.7rem; color: #64748b; text-transform: uppercase; letter-spacing: 0.05em; }\n.fp-info-val { font-size: 0.95rem; font-weight: 600; color: #e2e8f0; }\n\n/* ── Ratings row ─────────────────────────────────────────────────────── */\n\n.fp-ratings-row {\n  display: flex;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.fp-rating-card {\n  background: #1e293b;\n  border: 1px solid #334155;\n  border-radius: 10px;\n  padding: 0.85rem 1.25rem;\n  text-align: center;\n  min-width: 110px;\n}\n.fp-rating-val { font-size: 1.4rem; font-weight: 700; color: #f59e0b; }\n.fp-rating-label { font-size: 0.73rem; color: #64748b; margin-top: 0.15rem; }\n.fp-rd { color: #94a3b8; font-size: 0.7rem; }\n\n/* ── Sections ─────────────────────────────────────────────────────────── */\n\n.fp-section {\n  background: #1e293b;\n  border: 1px solid #334155;\n  border-radius: 12px;\n  padding: 1.25rem;\n}\n\n.fp-section-title {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: #94a3b8;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  margin: 0 0 1rem;\n}\n\n.fp-fight-count { color: #475569; font-weight: 400; text-transform: none; font-size: 0.8rem; }\n\n.fp-data-warning {\n  font-size: 0.78rem;\n  color: #92400e;\n  background: rgba(245, 158, 11, 0.08);\n  border: 1px solid rgba(245, 158, 11, 0.2);\n  border-radius: 6px;\n  padding: 0.5rem 0.75rem;\n  margin-bottom: 0.85rem;\n}\n.fp-data-warning a { color: #f59e0b; }\n\n/* ── Career stats grid ────────────────────────────────────────────────── */\n\n.fp-stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));\n  gap: 0.75rem;\n}\n\n.fp-stat-cell {\n  background: #0f172a;\n  border-radius: 8px;\n  padding: 0.7rem 0.85rem;\n}\n.fp-stat-val {\n  font-size: 1.15rem;\n  font-weight: 700;\n  color: #e2e8f0;\n}\n.fp-stat-unit { font-size: 0.7rem; color: #64748b; margin-left: 2px; }\n.fp-stat-label { font-size: 0.7rem; color: #64748b; margin-top: 0.2rem; }\n\n/* ── Fight history table ─────────────────────────────────────────────── */\n\n.fp-history-table-wrap {\n  overflow-x: auto;\n}\n\n.fp-history-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.855rem;\n}\n.fp-history-table th {\n  text-align: left;\n  color: #64748b;\n  font-size: 0.72rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  padding: 0.4rem 0.6rem;\n  border-bottom: 1px solid #334155;\n}\n.fp-history-table td {\n  padding: 0.5rem 0.6rem;\n  border-bottom: 1px solid #1a2740;\n  vertical-align: middle;\n}\n.fp-history-table tr:last-child td { border-bottom: none; }\n.fp-history-table tr:hover td { background: rgba(255,255,255,0.02); }\n\n.fp-hist-date { color: #64748b; white-space: nowrap; }\n.fp-hist-opp { color: #e2e8f0; font-weight: 500; }\n.fp-hist-method { color: #94a3b8; }\n.fp-hist-rnd { color: #94a3b8; text-align: center; }\n.fp-hist-time { color: #94a3b8; white-space: nowrap; }\n.fp-hist-event { color: #475569; font-size: 0.78rem; max-width: 200px; }\n\n.fp-result {\n  font-size: 0.72rem;\n  font-weight: 700;\n  padding: 0.15rem 0.45rem;\n  border-radius: 3px;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n.fp-result-win { background: rgba(16, 185, 129, 0.12); color: #10b981; }\n.fp-result-loss { background: rgba(239, 68, 68, 0.12); color: #ef4444; }\n.fp-result-draw { background: rgba(245, 158, 11, 0.12); color: #f59e0b; }\n.fp-result-nc { background: rgba(100, 116, 139, 0.12); color: #64748b; }\n\n/* ── Matchup panel ────────────────────────────────────────────────────── */\n\n.fp-matchup-panel {\n  background: #1e293b;\n  border: 1px solid #334155;\n  border-radius: 12px;\n  padding: 1.25rem;\n}\n\n.fp-matchup-search-row {\n  display: flex;\n  align-items: center;\n  gap: 0.85rem;\n  flex-wrap: wrap;\n  margin-bottom: 1rem;\n}\n\n.fp-matchup-vs {\n  color: #94a3b8;\n  font-size: 0.9rem;\n  white-space: nowrap;\n}\n\n.fp-odds-section { margin-top: 0.5rem; }\n\n.fp-odds-event {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  flex-wrap: wrap;\n  margin-bottom: 0.85rem;\n  padding-bottom: 0.75rem;\n  border-bottom: 1px solid #334155;\n}\n.fp-odds-event-name { color: #e2e8f0; font-weight: 600; font-size: 0.9rem; }\n.fp-odds-event-date { color: #64748b; font-size: 0.8rem; }\n\n.fp-title-badge {\n  font-size: 0.7rem;\n  font-weight: 700;\n  padding: 0.15rem 0.5rem;\n  border-radius: 3px;\n  background: rgba(245, 158, 11, 0.15);\n  color: #f59e0b;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.fp-status-badge {\n  font-size: 0.7rem;\n  font-weight: 600;\n  padding: 0.15rem 0.5rem;\n  border-radius: 3px;\n  text-transform: capitalize;\n}\n.fp-status-upcoming { background: rgba(16, 185, 129, 0.12); color: #10b981; }\n.fp-status-completed { background: rgba(100, 116, 139, 0.12); color: #64748b; }\n\n.fp-odds-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.875rem;\n}\n.fp-odds-table th {\n  text-align: left;\n  color: #64748b;\n  font-size: 0.72rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  padding: 0.4rem 0.75rem;\n  border-bottom: 1px solid #334155;\n}\n.fp-odds-table td {\n  padding: 0.55rem 0.75rem;\n  border-bottom: 1px solid #1a2740;\n}\n.fp-odds-table tr:last-child td { border-bottom: none; }\n.fp-odds-table tr:hover td { background: rgba(255,255,255,0.02); }\n\n.fp-bk-name { color: #94a3b8; }\n.fp-odds-val { font-weight: 700; font-size: 0.95rem; }\n.fp-odds-pos { color: #10b981; }\n.fp-odds-neg { color: #ef4444; }\n.odds-dash { color: #475569; }\n\n.fp-no-odds { color: #64748b; font-size: 0.875rem; margin: 0.5rem 0; }\n.fp-no-fight { color: #64748b; font-size: 0.875rem; margin: 0.5rem 0; }\n\n/* ── Probability bar ──────────────────────────────────────────────────────── */\n\n.fp-prob-section {\n  background: #0f172a;\n  border-radius: 10px;\n  padding: 1rem;\n  margin-bottom: 1rem;\n}\n\n.fp-prob-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.65rem;\n}\n\n.fp-prob-label {\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.fp-prob-method {\n  font-size: 0.7rem;\n  color: #475569;\n  font-style: italic;\n}\n\n.fp-prob-bar-wrap {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.fp-prob-name {\n  font-size: 0.78rem;\n  font-weight: 600;\n  white-space: nowrap;\n  min-width: 80px;\n}\n.fp-prob-a { color: #10b981; text-align: right; }\n.fp-prob-b { color: #f59e0b; }\n\n.fp-prob-bar {\n  flex: 1;\n  height: 10px;\n  border-radius: 5px;\n  overflow: hidden;\n  display: flex;\n  background: #1e293b;\n}\n\n.fp-prob-fill { height: 100%; transition: width 0.4s ease; }\n.fp-prob-fill-a { background: #10b981; }\n.fp-prob-fill-b { background: #f59e0b; }\n\n.fp-prob-pcts {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 0.35rem;\n}\n.fp-pct-a { font-size: 0.85rem; font-weight: 700; color: #10b981; }\n.fp-pct-b { font-size: 0.85rem; font-weight: 700; color: #f59e0b; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
